module.exports = __webpack_public_path__ + "static/media/aboutimg2.a7a74e12.jpg";